export default __webpack_public_path__ + "static/media/1-icon-gallery-view.8b713221.svg";